import { useState, useEffect } from "react";
import EditButton from "./EditButton";
import InputPW from "./InputPW";
import { API_BASE_URL } from "../../../config/api";

export default function ResetPassWordCard() {
  const [isEditing, setIsEditing] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordAgain, setNewPasswordAgain] = useState("");
  const [passwordValid, setPasswordValid] = useState(true);
  const [passwordAgainValid, setPasswordAgainValid] = useState(true);
  const [fieldsRequired, setFieldsRequired] = useState(false);
  const [oldPassInvalid, setOldPassInvalid] = useState(false);

  const [blur, setBlur] = useState({
    pass: false,
    newPass: false,
    newPassAgain: false,
  });
  function isValidPassword(password) {
    // must be at least 8 characters and contain at least:
    // one lowercase letter, one uppercase letter, one number, one special character
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    return regex.test(password);
  }

  useEffect(() => {
    if (!isValidPassword(newPassword)) {
      setPasswordValid(false);
    } else {
      setPasswordValid(true);
    }

    if (newPassword !== newPasswordAgain) {
      setPasswordAgainValid(false);
    } else {
      setPasswordAgainValid(true);
    }
    setFieldsRequired(false);
  }, [newPassword, newPasswordAgain, password]);

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
  };

  const handlePassChange = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/trader/change-password/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({
            password: password,
            new_password: newPassword,
          }),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/trader/change-password/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({
              password: password,
              new_password: newPassword,
            }),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        const data = await response.json();
        if (
          response.status === 400 &&
          data.password[0] === "Incorrect current password."
        ) {
          setOldPassInvalid(true);
          return;
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  const handleSave = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    // Here you could add save logic (API call, state update, etc.)
    handlePassChange();
  };

  return (
    <div className="w-full max-w-3xl rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-center justify-between">
        <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
          تغییر رمز عبور
        </span>
        <EditButton
          isEditing={isEditing}
          onEdit={handleEdit}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>

      <form
        className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6"
        onSubmit={handleSave}
      >
        {isEditing && (
          <InputPW
            label="رمز عبور فعلی"
            inputSample=""
            type="password"
            id="old"
            name="old"
            isReadOnly={!isEditing}
            isAuotComplete={true}
            onChange={(e) => {
              setPassword(e.target.value);
              setBlur((pre) => ({ ...pre, pass: false }));
              setOldPassInvalid(false);
            }}
            value={password}
            onBlur={() => setBlur((pre) => ({ ...pre, pass: true }))}
          />
        )}
        <div className="w-full hidden sm:block"></div>
        {isEditing ? (
          <>
            <InputPW
              label="رمز عبور جدید"
              inputSample=""
              type="password"
              id="new"
              name="new"
              isReadOnly={!isEditing}
              isAuotComplete={true}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setBlur((pre) => ({ ...pre, newPass: false }));
              }}
              value={newPassword}
              onBlur={() => setBlur((pre) => ({ ...pre, newPass: true }))}
            />
            <InputPW
              label="تکرار رمز عبور"
              inputSample=""
              type="password"
              id="repeat"
              name="repeat"
              isReadOnly={!isEditing}
              isAuotComplete={true}
              onChange={(e) => {
                setNewPasswordAgain(e.target.value);
                setBlur((pre) => ({ ...pre, newPassAgain: false }));
              }}
              value={newPasswordAgain}
              onBlur={() => setBlur((pre) => ({ ...pre, newPassAgain: true }))}
            />
            {fieldsRequired && (
              <p className="text-red-500 text-sm">
                لطفا تمامی فیلدها را پر کنید
              </p>
            )}
            {!passwordValid && blur.newPass && (
              <p className="text-red-500 text-sm">
                رمز عبور حداقل ۸ کاراکتر شامل عدد، حروف بزرگ و کوچک، کاراکتر
                ویژه
              </p>
            )}
            {!passwordAgainValid && blur.newPassAgain && (
              <p className="text-red-500 text-sm">رمزهای عبور مطابقت ندارند</p>
            )}
            {oldPassInvalid && (
              <p className="text-red-500 text-sm">
                رمز عبور فعلی را اشتباه وارد کرده اید
              </p>
            )}
          </>
        ) : (
          ""
        )}
      </form>
    </div>
  );
}
